import { render } from "./HeroiconsOutlineCode.vue?vue&type=template&id=567b706a"
const script = {}

import exportComponent from "/www/brandsecurity_2/nova/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"HeroiconsOutlineCode.vue"]])

export default __exports__